import { SETTING_KEYS } from 'src/constants';
import { get, post } from './Api';
import { UserSetting } from 'src/types/userSetting';
import { Settings } from 'src/types/settings';
import { gridColumnProperties } from 'src/types/gridColumnProperties';

async function setUserSettings(settings: UserSetting[]): Promise<any> {
  let updatedSettings = settings.map((s) => {
    return {
      settingKey: s.settingKey,
      settingValue: JSON.stringify(s.settingValue),
      smallScreen: s.smallScreen,
    } as UserSetting;
  });

  return post<any>('/user/userSettings', updatedSettings);
}

async function deleteUserSettings(settings: UserSetting[]): Promise<any> {
  let updatedSettings = settings.map((s) => {
    return {
      settingKey: s.settingKey,
      settingValue: null,
      smallScreen: s.smallScreen,
    } as UserSetting;
  });

  return post<any>('/user/deleteUserSettings', updatedSettings);
}

async function getUserSettings(smallScreen: boolean): Promise<UserSetting[]> {
  var settings = await get<UserSetting[]>('/user/userSettings?smallScreen=' + smallScreen);
  settings.forEach((s) => {
    if (s.settingKey === SETTING_KEYS.Settings) {
      s.settingValue = JSON.parse(s.settingValue as string) as Settings;
    } else {
      s.settingValue = JSON.parse(s.settingValue as string) as gridColumnProperties[];
    }
  });

  return settings;
}

export default {
  setUserSettings,
  getUserSettings,
  deleteUserSettings,
};
